module.exports = {
  API_URL: "https://dbpatb2zpylw8.cloudfront.net/api",
  // API_URL: "https://d3d7cdbpcxi24d.cloudfront.net/api",
  PRODUCT_S3: "https://capno-product-image.s3.amazonaws.com",
  // API_URL : "http://localhost:3002/api",
};
